import React from 'react'
import layoutStyles from '../../containers/AppLayout/styles.module.less'
import { useAccountSearch } from '../../hooks'
import { MessageCenter } from '../MessageCenter'
import styles from './AccountSearchResults.module.less'
import { AccountSearchBar, AccountsTable, SearchResultsSummary } from './index'

const AccountSearchResults = () => {
  const {
    accountSearchState,
    accountSearchState: { accountResults, errorMessage, loadingResults },
  } = useAccountSearch()
  return (
    <>
      <div className={layoutStyles.offsetBar}>
        <AccountSearchBar />
        {errorMessage && (
          <div className={styles.messageBanner}>
            <MessageCenter errorMessages={[errorMessage]} />
          </div>
        )}
      </div>
      {!loadingResults && !errorMessage && (
        <>
          <SearchResultsSummary accountSearchState={accountSearchState} />
          {accountResults.length > 0 && <AccountsTable accountResults={accountResults} />}
        </>
      )}
    </>
  )
}

export default AccountSearchResults
